import { format, processNamespace, text } from '@opengov/locale/namespaces';

export const appCore = {
  errors: {
    severeErrorTitle: text(),
    severeErrorMsg: text(),
    severeErrorCode: format<{ code: string }>()
  }
};

export const appCoreMsgs = processNamespace({ appCore }).appCore;

export type IAppCoreNamespace = typeof appCore;
